import React from 'react';
import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import useAppContext from 'flow/hooks/useAppContext';

const UnableToPlayAudioNotifier = () => {
    const { i18next } = useAppContext();

    const onAccept = () => {
        // No-op. All we need is an interaction, like... any interaction!
    };

    return (
        <NotifierBanner
            theme="warning"
            message={i18next.t(
                'app.window.notification.enable_audio.description',
            )}
            buttonText={i18next.t('app.window.notification.enable_audio')}
            handleClick={onAccept}
        />
    );
};

export default UnableToPlayAudioNotifier;
